import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { abTestsApi } from '../api/abTests';
import type { TestStatus, TestType } from '../api/abTests';

export function useAbTests(filters?: { status?: TestStatus; test_type?: TestType }, page = 1) {
  return useQuery({
    queryKey: ['ab-tests', { ...filters, page }],
    queryFn: () => abTestsApi.list({ ...filters, page }),
  });
}

export function useAbTest(id: number | null) {
  return useQuery({
    queryKey: ['ab-tests', id],
    queryFn: () => abTestsApi.find(id!),
    enabled: id !== null,
  });
}

export function useGenerateAbTests() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (auditRunId?: number) => abTestsApi.generate(auditRunId),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['ab-tests'] }),
  });
}

export function useUpdateAbTestStatus() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, status }: { id: number; status: TestStatus }) =>
      abTestsApi.updateStatus(id, status),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['ab-tests'] }),
  });
}

export function useDeleteAbTest() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: abTestsApi.destroy,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['ab-tests'] }),
  });
}
